<template>
  <div class="col-6">
    <div class="row">
      <settings />
    </div>
  </div>
</template>

<script>
  import Settings from '@mailer/components/messages/messages-settings';

  export default {
    components: {
      Settings
    }
  };
</script>
